module.exports = __webpack_public_path__ + "static/media/poker-night.419744a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/rimages/poker-night.jpg
// module id = 93
// module chunks = 0